import { NavItemId } from '../interfaces';

export const AUTH_MAIN_NAV_TREE: NavItemId[] = ['statistic', 'tools', 'affiliatePrograms'];

export const AUTH_BURGER_MAIN_TREE = AUTH_MAIN_NAV_TREE;

export const GUEST_MAIN_NAV_TREE: NavItemId[] = [
    'webmasters',
    'advertisers',
    'affiliatePrograms',
    'help',
];

export const USER_MENU_TREE: NavItemId[] = [
    'profile',
    'dashboard',
    'trafficSources',
    'acts',
    'learning',
    'faq',
    'logout',
];

export const BURGER_AUTH_USER_MENU_TREE: NavItemId[] = [
    'dashboard',
    'trafficSources',
    'acts',
    'learning',
    'faq',
    'logout',
];
